import { Grid, Tooltip, makeStyles } from '@material-ui/core';
import React from 'react';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import styles from './styles';

export interface Props {
  title: string;
  disabled?: boolean;
  overrideClasses?: any;
}

const ExplanationHover = ({ title, disabled, overrideClasses }: Props) => {
  const useStyles = makeStyles(styles(overrideClasses));
  const classes = useStyles();

  return (
    <Grid
      data-testid={'autosky-explanationhover'}
      className={classes.explanationHover}
    >
      <Tooltip
        disableHoverListener={disabled}
        placement="top"
        arrow
        title={title}
      >
        <InfoIcon
          fontSize="small"
          className={classes.icon}
          color={disabled ? 'disabled' : 'action'}
        />
      </Tooltip>
    </Grid>
  );
};

export default ExplanationHover;
